export const S3_HOSTNAME = 'https://ebs-society-portal-data.s3.ap-northeast-1.amazonaws.com';